export default "__VITE_ASSET__IV9QKHaS__"